import http from '@/plugs/httpServer';
import { serverName } from '@wj/common'
let feather_campus = "feather-campus"

// 积分类别查询
export function getUser(data: object) {
    return http({
        method: 'GET',
        url: `${serverName.feather_hr}/auth/getUserInfoByToken`,
        params: data,
    })
}


// 用户登录
export function login(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/auth/login`,
        data: data,
    })
}
// 用户登录
export function register(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/auth/register`,
        data: data,
    })
}


